<div class="logo" (click)="goHome()">
  <img [src]="(headerUrl$ | async)" draggable="false" loading="eager" fetchpriority=high alt="Logo"/>
</div>
